import _ from 'lodash';
import commonConfig from '../config/commonConfig';
// const isServerContext = !!process?.env?.SSR;
var BASE_DOMAINS = {
    QCMAIN_HOST: 'intl.cloud.tencent.com',
    QCLOUD_ROOT_HOST: 'cloud.tencent.com',
    QCCONSOLE_HOST: 'console.intl.cloud.tencent.com',
    QCCONSOLE_CN_HOST: 'console.cloud.tencent.com',
    QCBUY_HOST: 'buy.intl.cloud.tencent.com',
    QCBUY_CN_HOST: 'buy.cloud.tencent.com'
};
/**
 * 生成需要的各种相对域名（控制台、购买页等）
 * @param  {String} host 基础host
 * @return {{QCMAIN_HOST: string, QCCONSOLE_HOST: string, QCLOUD_ROOT_HOST: string,
 * QCBUY_HOST: string, QCCONSOLE_CN_HOST: string}} 各类域名
 * @author yuiffydong
 */ export function getDomains(host) {
    var QCMAIN_HOST = host || BASE_DOMAINS.QCMAIN_HOST;
    var QCLOUD_ROOT_HOST = QCMAIN_HOST.replace(/^(dev.)?intl\./, '').replace(/:\d+$/, ''); // 根域名（中国站域名）。去除首部dev和尾部端口号，以便本地调试也能正常使用
    var QCCONSOLE_HOST = "console.intl.".concat(QCLOUD_ROOT_HOST); // 国际控制台域名
    var QCCONSOLE_CN_HOST = "console.".concat(QCLOUD_ROOT_HOST); // 中国站控制台域名，用于一些域名替换
    var QCBUY_HOST = "buy.intl.".concat(QCLOUD_ROOT_HOST); // 国际购买页域名
    var QCBUY_CN_HOST = "buy.".concat(QCLOUD_ROOT_HOST); // 中国站购买页域名
    return {
        QCMAIN_HOST: QCMAIN_HOST,
        QCLOUD_ROOT_HOST: QCLOUD_ROOT_HOST,
        QCCONSOLE_HOST: QCCONSOLE_HOST,
        QCCONSOLE_CN_HOST: QCCONSOLE_CN_HOST,
        QCBUY_HOST: QCBUY_HOST,
        QCBUY_CN_HOST: QCBUY_CN_HOST
    };
}
/**
 * 获取各种相对路径域名
 * @returns {{QCMAIN_HOST: string, QCCONSOLE_HOST: string, QCLOUD_ROOT_HOST: string,
 * QCBUY_HOST: string, QCCONSOLE_CN_HOST: string}} 各类域名
 * @author yuiffydong
 */ export var getDomainInfos = function() {
    return BASE_DOMAINS;
};
/**
 * 将url转化为符合相应域名（比如当前域名是intl.cloud.tencent.cn，就要把console.intl.cloud.tencent.com转化为console.intl.cloud.tencent.cn）的url。
 * 用于后台数据中获取的链接。
 * @param  {String} srcUrl 需要被转换的url
 * @return {String} 转换后的url
 * @author yuiffydong
 */ export var formatUrlDomain = function(srcUrl) {
    var ref = parseUrl(srcUrl), protocal = ref.protocal, host = ref.host, path = ref.path;
    var keepUnnecessaryDomainInUrl = _.get(commonConfig, 'domainFormatConfig.keepUnnecessaryDomainInUrl') || false;
    if (!keepUnnecessaryDomainInUrl && host === BASE_DOMAINS.QCMAIN_HOST) {
        // 如果是官网域名，则用相对路径，不带域名
        protocal = '';
        host = '';
        if (!path) path = '/'; // 如果只有域名没有path，则path写个斜杠，以便返回一个"/"相对路径的首页
    } else if (host) {
        // 非官网域名，则进行域名转换
        host = hostRelative(host);
    }
    var ret = "".concat(protocal).concat(host).concat(path) || srcUrl;
    // console.log('formatUrlDomain', srcUrl, {protocal, host, path, ret});
    return ret;
};
export var isForeignLink = function(redirectUrl) {
    var host = parseUrl(redirectUrl).host;
    return !Object.values(BASE_DOMAINS).includes(host);
};
var parseUrl = function(srcUrl) {
    var protocal;
    var host;
    var path;
    if (srcUrl && /^((?:https?:)?\/\/)([^/]+)(\/.*)?$/.test(srcUrl.trim())) {
        protocal = RegExp.$1;
        host = RegExp.$2;
        path = RegExp.$3;
    } else {
        protocal = '';
        host = '';
        path = srcUrl;
    }
    var ret = {
        protocal: protocal,
        host: host,
        path: path
    };
    // console.log('parseUrl', srcUrl, ret);
    return ret;
};
var hostRegex = new RegExp("^".concat(Object.values(BASE_DOMAINS).join('|'), "$"));
/**
 * 把基础的.com的host转换为根据当前域名的相对域名(.com.cn/.cn）
 * @param {String} host 基本域名，如intl.console.cloud.tencent.com
 * @returns {String} 相对的域名，如intl.console.cloud.tencent.cn
 */ var hostRelative = function(host) {
    var domainInfos = getDomainInfos();
    var domainMap = {};
    Object.keys(BASE_DOMAINS).forEach(function(domainKey) {
        if (domainInfos[domainKey]) domainMap[BASE_DOMAINS[domainKey]] = domainInfos[domainKey];
    });
    return host.replace(hostRegex, function(matched) {
        return domainMap[matched];
    });
};
/**
 * 对整篇文本中的链接的域名进行处理，把基础的.com的host转换为根据当前域名的相对域名(.com.cn/.cn）
 * @param {String} host 原文本
 * @param {{domainInfos: {QCMAIN_HOST: string, QCCONSOLE_HOST: string, QCLOUD_ROOT_HOST: string,
 * QCBUY_HOST: string, QCCONSOLE_CN_HOST: string}}} options 设置。可以通过domainInfos设置指定各个域名，而不是用自动获取的域名。
 * @returns {String} 处理后文本
 */ export var hostRelativeReplaceAll = function(text) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var domainInfos = _.get(options, 'domainInfos');
    if (!domainInfos) domainInfos = getDomainInfos();
    var domainMap = {};
    Object.keys(BASE_DOMAINS).forEach(function(domainKey) {
        if (domainInfos[domainKey]) domainMap["//".concat(BASE_DOMAINS[domainKey])] = "//".concat(domainInfos[domainKey]);
    });
    var urlRegexG = new RegExp("".concat(Object.values(BASE_DOMAINS).map(function(domain) {
        return "//".concat(domain);
    }).join('|')), 'g');
    // console.log('urlRegexG', urlRegexG);
    return text.replace(urlRegexG, function(matched) {
        return "".concat(domainMap[matched]);
    });
};
